import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  fetchSetReviewReactionWeb,
  ISetReviewReactionWebResponse200,
  ISetReviewReactionWebResponse400,
} from '../../repositories/newbuilding-reviews/v1/set-review-reaction-web';

import { TThunkAction } from '../../types/redux/thunk';

import { EStatus } from '../../types/developerV2/review';
import { setReviewReactionAction } from './actions';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_review_reaction/SetReviewReactionRequestSchema';

interface IParams {
  reviewId: string;
  type: EStatus;
}

export const setReviewReaction = ({ reviewId, type }: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { response, statusCode } = await fetchSetReviewReactionWeb<
        ISetReviewReactionWebResponse200,
        ISetReviewReactionWebResponse400
      >({
        httpApi,
        parameters: { reviewId, type: type as unknown as EType },
      });

      if (statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode,
          message: 'Ошибка запроса на изменение реакции',
          domain: 'src/browser/services/reviews/setReviewReaction.ts',
        });
      }

      dispatch(setReviewReactionAction({ reviewId, type: response.type as unknown as EStatus }));
    } catch (error) {
      logger.error(error, {
        domain: 'setReviewReaction',
        message: error.message,
      });
    }
  };
};
